import { render } from "./VoucherConfig.vue?vue&type=template&id=24517dce"
import script from "./VoucherConfig.vue?vue&type=script&lang=ts"
export * from "./VoucherConfig.vue?vue&type=script&lang=ts"
script.render = render

export default script